import React from "react"

import styles from "./hero-home-divisor.module.css"

export default function HeroHomeDivisor() {
  return <div className={styles.heroDivisor}></div>
}
